import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={37}
            height={37}
            viewBox="0 0 37 37"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M.92 10.063A9.485 9.485 0 0110.407.578h8.278c9.81 0 17.763 7.953 17.763 17.763 0 9.81-7.953 17.763-17.763 17.763-9.81 0-17.763-7.952-17.763-17.763v-8.278z"
                fill={theme["#B4E3E1"]}
            />
            <path
                d="M25.292 19.229c-.196 0-.4-.063-.595-.107a8.386 8.386 0 01-1.164-.346 1.777 1.777 0 00-2.202.888l-.196.4a10.816 10.816 0 01-2.362-1.777 10.822 10.822 0 01-1.777-2.362l.373-.249a1.776 1.776 0 00.889-2.203 9.191 9.191 0 01-.347-1.163c-.044-.196-.08-.4-.106-.604a2.664 2.664 0 00-2.665-2.212h-2.664a2.665 2.665 0 00-2.665 3.029 16.875 16.875 0 0014.672 14.62h.338a2.664 2.664 0 002.435-1.58c.153-.344.231-.717.23-1.094v-2.665a2.664 2.664 0 00-2.194-2.575zm.444 5.329a.888.888 0 01-.643.854.939.939 0 01-.387.034A15.098 15.098 0 0111.64 12.319a.966.966 0 01.222-.729.888.888 0 01.666-.301h2.664a.888.888 0 01.888.701c.036.243.08.483.134.72.102.468.239.928.408 1.376l-1.243.578a.89.89 0 00-.435 1.18 12.87 12.87 0 006.217 6.218.888.888 0 00.675 0 .89.89 0 00.506-.462l.55-1.243c.46.164.928.3 1.404.408.237.053.477.098.72.133a.888.888 0 01.701.889l.018 2.77z"
                fill={theme["#0D968F"]}
            />
        </svg>
    )
}
  
  export default SvgComponent